/* globals Player */

import {modalsBehavior} from './modals.js';
import { helpers } from '../common/helpers.js';

function initVideoButtons() {
	let color = 'd52340';

	if ($('.park-futuro').length) {
		color = '25b7cc';
	}

	if ($('.park-avenue').length) {
		color = '01a8a6';
	}

	if ($('.park-fonte').length) {
		color = '1d9b85';
	}

	$('.js-video-start').on('click', (e) => {
		let $parent = $(e.currentTarget).parent();
		let $container = $(e.currentTarget).siblings('.video-container');
		let link = $container.data('src');
		let $videoBlock;

		if (link.indexOf('vimeo') !== -1) {
			// videoPlayers.forEach((elem) => {
			// 	if (elem) {
			// 		elem.pause();
			// 	}
			// });

			// let player = new Player($container[0], {
			// 	id: link,
			// 	autoplay: true,
			// 	title: false,
			// 	byline: false,
			// 	portrait: false,
			// 	badge: false,
			// 	color,
			// });

			// player.on('loaded', () => {
			// 	$container.find('> iframe').attr('allow', 'autoplay; fullscreen');
			// })

			$videoBlock = $(`<iframe src="${link}?color=${color}&autoplay=1&title=0&byline=0&portrait=0" frameborder="0" allowfullscreen allowautoplay></iframe>`);
		} else {
			$videoBlock = $(`<iframe src="${link}" frameborder="0" allowfullscreen></iframe>`);
		}

		if ($(e.currentTarget).hasClass('js-video-modal')) {
			modalsBehavior.show('video', $videoBlock);
		} else {
			$container.append($videoBlock[0]);
			$parent.addClass('is-inited');
		}
	});
}

initVideoButtons();

$(document).on('hero.isShown', () => {
	$('.js-video-autoplay').each((i, video) => {
		video.play();
	});
});

if ($('.mediarow__media video').length) {
	$('.mediarow__media').hover((e) => {
		$(e.currentTarget).find('video')[0].play();
	});

	$('.mediarow .button').hover((e) => {
		$(e.currentTarget).closest('.mediarow').find('video')[0].play();
	});

	$('.mediarow input').on('mouseover focus', (e) => {
		$(e.currentTarget).closest('.mediarow').find('video')[0].play();
	});

	$('.mediarow__stats').hover((e) => {
		$(e.currentTarget).closest('.mediarow').find('video')[0].play();
	});

	$(window).on('scroll', (e) => {
		if (helpers.isElementPartiallyInViewport($('.mediarow__media')[0], 50) && !$('.mediarow__media').hasClass('is-inview')) {
			$('.mediarow__media').addClass('is-inview');
			$('.mediarow__media').find('video')[0].play();
		} else if (!helpers.isElementPartiallyInViewport($('.mediarow__media')[0], 50)) {
			$('.mediarow__media').removeClass('is-inview');
		}
	});
}

class GiftVideo {
	constructor($block) {
		// blocks
		this.$container = $block;
		this.$playBtn = $block.find('.js-play');
		this.$pauseBtn = $block.find('.js-pause');
		this.$durationBlock = $block.find('.js-duration');
		this.$previewBlock = $block.find('.gift__video .preview');
		this.previewBlockVideo = this.$previewBlock.find('video')[0];
		this.previewBlockImg = this.$previewBlock.find('img')[0];
		this.$videoBlock = $block.find('.gift__video .video');
		this.videoBlockVideo = this.$videoBlock.find('video')[0];

		this.resizableItems = [
			this.videoBlockVideo,
		];

		if (this.previewBlockVideo) {
			this.resizableItems.push(this.previewBlockVideo);
		}

		if (this.previewBlockImg) {
			this.resizableItems.push(this.previewBlockImg);
		}

		//
		this.isPlaying = false;
		this.inProgress = false;

		//
		this.resize();
		this.addListeners();
		this.toggleVideoPreview();
	}

	addListeners() {
		let self = this;

		// video
		if (!isNaN(this.videoBlockVideo.duration)) {
			let time = self.humanizeTime(self.videoBlockVideo.duration);

			self.$durationBlock.text(`${time.minutes}:${time.seconds}`);
		} else {
			self.videoBlockVideo.addEventListener('durationchange', function() {
				let time = self.humanizeTime(self.videoBlockVideo.duration);

				self.$durationBlock.text(`${time.minutes}:${time.seconds}`);
			});
		}

		this.videoBlockVideo.addEventListener('timeupdate', () => {
			let time = self.humanizeTime(self.videoBlockVideo.duration - self.videoBlockVideo.currentTime);

			self.$durationBlock.text(`${time.minutes}:${time.seconds}`);
		});

		this.videoBlockVideo.addEventListener('play', () => {
			self.playHandler();
		});

		this.videoBlockVideo.addEventListener('ended', () => {
			self.inProgress = false;
			self.goToStart();
			self.videoBlockVideo.currentTime = 0;
		});

		// controls
		this.$playBtn.on('click', () => {
			self.play();
		});

		this.$pauseBtn.on('click', () => {
			self.pause();
		});

		// video-preview
		$(window).on('scroll', () => {
			self.toggleVideoPreview();
			self.checkVideoInView();
		});

		// resize
		$(window).on('resize', () => {
			self.resize();
		});
	}

	humanizeTime(value) {
		return {
			minutes: helpers.formatNumber(parseInt(value / 60, 10)),
			seconds: helpers.formatNumber(parseInt(value % 60)),
		}
	}

	toggleVideoPreview() {
		let self = this;

		if (this.previewBlockVideo) {
			if (helpers.isElementPartiallyInViewport(self.$container[0]) && !self.$container.hasClass('is-preview-playing')) {
				self.$container.addClass('is-preview-playing');
				self.startVideoPreview();
			} else if (!helpers.isElementPartiallyInViewport(self.$container[0])) {
				self.$container.removeClass('is-preview-playing');
			}
		}
	}

	stopVideoPreview() {
		if (this.previewBlockVideo) {
			this.previewBlockVideo.pause();
		}
	}

	startVideoPreview() {
		if (this.previewBlockVideo) {
			this.previewBlockVideo.currentTime = 0;

			let promise = this.previewBlockVideo.play();

			if (promise !== undefined) {
				promise.catch(error => {
					console.log(error);
				}).then(() => {
					// play started
				});
			}
		}
	}

	checkVideoInView() {
		if (!helpers.isElementPartiallyInViewport(this.$container[0], 0) && this.$container.hasClass('is-playing')) {
			this.pause();
		}
	}

	play() {
		let promise = this.videoBlockVideo.play();

		if (promise !== undefined) {
			promise.catch(error => {
				console.log(error);
			}).then(() => {
				// play started
			});
		}
	}

	pause() {
		this.videoBlockVideo.pause();
		this.isPlaying = false;
		this.$container.removeClass('is-playing');
	}

	goToStart() {
		this.isPlaying = false;
		this.$container.removeClass('is-playing is-inprogress');
		this.startVideoPreview();
	}

	playHandler() {
		this.isPlaying = true;
		this.inProgress = true;

		this.$container.addClass('is-playing is-inprogress');

		this.stopVideoPreview();
	}

	resize() {
		this.resizableItems.forEach((item) => {
			helpers.calc_bg_object(item, this.$container[0], item.getAttribute('data-width'), item.getAttribute('data-height'));
		});
	}
}

if ($('.gift').length) {
	new GiftVideo($('.gift'));
}
